'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Carousel } from '../ui/carousel';
import { useCarouselContext } from '@eliadmin/core/src/components/ui/carousel-context';
import { CarouselControls } from '@eliadmin/core/src/components/ui/carousel-controls';

export function ReelsCarousel() {
  const options = {
    align: 'center' as const,
  };

  const data = [
    {
      image: { url: '/images/reels/1.jpg' },
      name: 'Reel 1',
    },
    {
      image: { url: '/images/reels/2.png' },
      name: 'Reel 2',
    },
    {
      image: { url: '/images/reels/3.png' },
      name: 'Reel 3',
    },
    {
      image: { url: '/images/reels/4.png' },
      name: 'Reel 4',
    },
    {
      image: { url: '/images/reels/5.png' },
      name: 'Reel 5',
    },
    {
      image: { url: '/images/reels/6.png' },
      name: 'Reel 6',
    },
    {
      image: { url: '/images/reels/7.png' },
      name: 'Reel 7',
    },
    {
      image: { url: '/images/reels/1.jpg' },
      name: 'Reel 8',
    },
    {
      image: { url: '/images/reels/2.png' },
      name: 'Reel 9',
    },
    {
      image: { url: '/images/reels/3.png' },
      name: 'Reel 10',
    },
  ];

  const carouselContext = useCarouselContext();

  if (!carouselContext) {
    throw new Error('Hero must be used within a CarouselProvider');
  }

  const { selectedIndex } = carouselContext;

  return (
    <section
      className={cn(
        'relative flex items-center justify-center bg-[#F2EDE6] px-0 py-[25px] sm:py-8 lg:py-[50px]',
      )}
    >
      <div
        className={cn(
          'custom-container',
          'absolute left-1/2 top-1/2 z-10 flex -translate-x-1/2 -translate-y-1/2 items-center justify-between px-4 xl:px-0',
        )}
      >
        <CarouselControls
          buttonProps={{ size: 'icon-lg', variant: 'white', rounded: 'md' }}
          className={{
            main: 'flex w-full items-center justify-between gap-2 sm:gap-3 lg:gap-4',
            button:
              'h-10 w-10 border-none bg-white text-foreground shadow-none sm:h-12 sm:w-12 lg:max-h-[52px] lg:min-h-[52px] lg:min-w-[52px] lg:max-w-[52px]',
          }}
        />
      </div>
      <Carousel
        options={options}
        enableLoop
        className={{
          main: 'w-full',
          container: 'h-[379px] w-full items-center sm:h-[445px] lg:h-[488px]',
          wrapper: 'w-full',
          slide:
            'mx-2 aspect-[9/16] w-full overflow-hidden rounded-[16px] transition-all sm:mx-2.5 lg:mx-3',
          activeSlider:
            'aspect-[9/16] h-fit max-w-[213px] transition-all sm:max-w-[250px] lg:max-w-[274px]',
          inactiveSlider:
            'aspect-[9/16] h-fit max-w-[180px] transition-all sm:max-w-[210px] lg:max-w-[230px]',
        }}
        slides={data.map((reel, index) => (
          <ReelCard key={reel.name} reel={reel} isActiveSlide={selectedIndex === index} />
        ))}
      />
    </section>
  );
}

function ReelCard({
  reel,
  isActiveSlide,
}: {
  reel: { image: { url: string }; name: string };
  isActiveSlide?: boolean;
}) {
  return (
    <div className="relative h-full w-full">
      {isActiveSlide && (
        <Image
          src={'/images/play.svg'}
          alt="Play"
          width={40}
          height={40}
          className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2"
        />
      )}

      <Image
        src={reel.image.url}
        alt={resolveImageAlt(reel?.image, reel?.name)}
        width={0}
        height={0}
        className="absolute inset-0 z-0 h-full w-full object-cover object-center"
        sizes="(min-width: 1024px) 274px, (min-width: 640px) 250px, 213px"
      />
    </div>
  );
}
